import { newDtScope } from '@knowledge/knowledges/general/edit/selectors/time/helper';

export function newCondition(): Knowledge.Condition {
  return {
    storeScope: {
      storeType: 'ALL',
      storeScope: [],
    },
    itemScope: {
      filterCode: 'ITEM_ALL',
      specifiedItems: [],
      exclude: [],
      saleTypes: ['ONSALE', 'PREORDER'],
    },
    dtScope: {
      ...newDtScope(),
      filterCode: 'DT_ALL',
    },
    tradeStatusScope: {
      filterCode: 'TRADE_STATUS_ALL',
      tradeStatusList: [],
    },
  };
}

export function newKnowledge(): Knowledge.FormValue {
  return {
    conditions: [newCondition()],
    contentValue: {
      templateCode: undefined,
      content: '',
    },
  };
}
